module.exports = __webpack_public_path__ + "img/logo.0fd3b84b.png";